import { alpha, Box, styled, Typography } from '@sb/cc-design-system';

export const OverrideLeftSideBarHeader = styled(Typography)(
  ({ theme }) => `
  margin-bottom: 16px;
  text-align: center;
  color: ${alpha(theme.palette.secondary.contrastText, 0.6)};
`,
);

export const OverrideLeftSideBarContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: calc(100% - 36px);
`;

export const ButtonContentWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;

  > svg {
    font-size: 16px;
  }
`;

export const ScheduleCardWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow-y: auto;
`;

export const ScheduleCard = styled(Box)(
  ({ theme }) => `
  width: 100%;
  margin-top: 16px;
  border-radius: 8px;
  border: 1px solid ${theme.palette.grey[600]};
`,
);

export const ScheduleCardHeader = styled(Box)(
  ({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: ${theme.palette.grey[200]};

  > svg {
   color: ${theme.palette.grey[800]};
   font-size: 18px;
   cursor: pointer;
  }
`,
);

export const ScheduleCardTitleWrapper = styled(Box)`
  flex: 1;
  display: flex;
  gap: 16px;
  align-items: center;

  > svg {
    font-size: 18px;
    color: ${alpha('#000', 0.54)};
  }

  > p {
    flex: 1;
  }
`;

export const ScheduleCardContentWrapper = styled(Box)<{
  $isDraftProductLineup?: boolean;
}>(
  ({ $isDraftProductLineup = false }) => `
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 16px;
  padding: 16px 0 ${$isDraftProductLineup ? '0' : '16px'};
`,
);

export const ScheduleCardFieldItemWrapper = styled(Box)<{
  $fullWidth?: boolean;
}>(
  ({ $fullWidth = false }) => `
  display: flex;
  flex-direction: column;
  gap: 4px;
  
  &:nth-child(even) {
    padding-right: 16px;
  }

  &:nth-child(odd) {
    padding-left: 16px;
  }

  ${
    $fullWidth
      ? `
      width: 100%;
      padding: 0 16px;
    `
      : `
      width: 50%;
    `
  }
  color: #000;

  svg {
    font-size: 15px;
  }
`,
);

export const ScheduleCardFieldItemLabelWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;

  > svg {
    color: ${alpha('#000', 0.56)};
  }
`;

export const ScheduleCardFieldItemValueWrapper = styled(
  ScheduleCardFieldItemLabelWrapper,
)(
  ({ theme }) => `
  color: ${theme.palette.text.primary};
  width: 100%;

  > svg {
   color: ${theme.palette.grey[800]};
  }
`,
);

export const DatePickerWrapper = styled(Box)`
  width: 100%;
`;

export const BackupListWrapper = styled(Box)`
  width: 100%;
`;

export const BackupListItem = styled(Box)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: 40px;
  padding: 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.palette.grey[500]};
  }
`,
);

export const BackupName = styled(Typography)`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
